<template>
  <div>
  </div>
</template>

<script>
import firebase from 'firebase'
import db from './fireBaseInit'
export default {
  data () {
    return {
      progressUpload: 0,
      file: File,
      uploadTask: '',
      downloadURL: '',
      uploading: false,
      snackbar: false
    }
  },
  props: ['freightID', 'fileList'],
  components: {},
  methods: {
    detectFiles (fileList) {
      Array.from(Array(fileList.length).keys()).map(x => {
        this.uploadFile(fileList[x])
      })
    },
    uploadFile (file) {
      var vm = this
      var storageRef = firebase.storage().ref()
      var id = this.freightID
      console.log(this.freightID)
      var uploadTask = storageRef.child(this.freightID + '/' + file.name).put(file)

      uploadTask.on('state_changed', function (snapshot) {
        // Observe state change events such as progress, pause, and resume
        // Get task progress, including the number of bytes uploaded and the total number of bytes to be uploaded
        this.progressUpload = (snapshot.bytesTransferred / snapshot.totalBytes) * 100
        console.log('Upload is ' + this.progressUpload + '% done')
        vm.$emit('bytes', this.progressUpload)
        switch (snapshot.state) {
          case firebase.storage.TaskState.PAUSED: // or 'paused'
            console.log('Upload is paused')
            break
          case firebase.storage.TaskState.RUNNING: // or 'running'
            console.log('Upload is running')
            break
        }
      }, function (error) {
        // Handle unsuccessful uploads
        console.log(error)
      }, function () {
        // Handle successful uploads on complete
        console.log(uploadTask.snapshot)
        var img = {}
        img['BOL'] = uploadTask.snapshot.downloadURL
        img['File'] = file.name
        this.downloadURL = img
        db.collection('freight').doc(id).update(img)
        vm.$emit('finished')
      })
    }
  },
  watch: {
    downloadURL: function () {
      this.updateFirestore()
    },
    fileList: function () {
      this.uploadFile(this.fileList)
    }
  }
}
</script>

<style scoped>
.jbtn-file {
  cursor: pointer;
  position: relative;
  overflow: hidden;
}
.jbtn-file input[type='file'] {
  position: absolute;
  top: 0;
  right: 0;
  min-width: 100%;
  min-height: 100%;
  text-align: right;
  filter: alpha(opacity=0);
  opacity: 0;
  outline: none;
  cursor: inherit;
  display: block;
}
</style>



// WEBPACK FOOTER //
// src/components/FileUploader.vue